import { z } from 'zod';
import { ROLES } from '../constants.js';
import { emailSchema, idSchema, isoDateTime } from './common.js';
export const roleSchema = z.enum(ROLES);
export const userSchema = z.object({
    id: idSchema,
    email: emailSchema,
    name: z.string().min(1).max(120),
    role: roleSchema,
    status: z.enum(['active', 'disabled']).default('active'),
    lastLoginAt: isoDateTime.nullish(),
    createdAt: isoDateTime,
});
export const loginRequestSchema = z.object({
    email: emailSchema,
    /** Plaintext over TLS; never stored. */
    password: z.string().min(8).max(200),
});
export const authSessionSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    /** Seconds until accessToken expires. */
    expiresIn: z.number().int(),
    tokenType: z.literal('Bearer'),
    user: userSchema,
});
export const refreshRequestSchema = z.object({
    refreshToken: z.string().min(10),
});
export const createUserSchema = z.object({
    email: emailSchema,
    name: z.string().min(1).max(120),
    role: roleSchema,
    password: z.string().min(10).max(200),
});
export const updateUserSchema = z
    .object({
    name: z.string().min(1).max(120).optional(),
    role: roleSchema.optional(),
    status: z.enum(['active', 'disabled']).optional(),
    password: z.string().min(10).max(200).optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'No fields to update' });
export const apiTokenSchema = z.object({
    id: idSchema,
    name: z.string().min(1).max(120),
    /** Display prefix only — the full token is returned once at creation. */
    prefix: z.string(),
    role: roleSchema,
    lastUsedAt: isoDateTime.nullish(),
    expiresAt: isoDateTime.nullish(),
    revokedAt: isoDateTime.nullish(),
    createdAt: isoDateTime,
});
//# sourceMappingURL=user.js.map